import DataSourceConfig from '../Config/DataSourceConfig';
import SystemDataService from '../Services/SystemDataService';
import { ASSETS } from './assets-data';

// Real MaestroShield Google reviews for design-time rendering. Shape mirrors the
// S3 `reviews` collection consumed by ReviewCard: { name, shortText, reviewText,
// reviewDate, image }. `image` is optional, the card falls back to a colored
// initial avatar. Keep the shape stable so a section can flip local↔backend with
// no code change (see DataSourceConfig). For production these should be seeded to
// S3 and `reviews` flipped to 'backend'.
const LOCAL_REVIEWS_EN = [
    {
        name: 'Anna Lamb',
        shortText: 'Went Above And Beyond',
        reviewText: "I really appreciate this company. I work for a window/door business and nobody had the kind of remote I needed so I got recommended this company from AHC. I forgot who I talked to but I think it was Shari. HUGGEEE shout out to her and the team for getting me exactly what I needed!",
        reviewDate: '3 months ago',
        image: ASSETS.MAESTRO_SHEILD_REVIEW_1,
    },
    {
        name: 'Olivia Mutelet',
        shortText: 'Amazing Team & Products',
        reviewText: 'We have worked with them for a couple years now. Very easy to communicate and work with them. The team is unbelievable! Always a joy to speak to them which is important! "Communication" and love their products.',
        reviewDate: '2 years ago',
        image: ASSETS.MAESTRO_SHEILD_REVIEW_2,
    },
    {
        name: 'J.R. Little',
        shortText: 'Solid, Dependable Product',
        reviewText: 'Michael is a great representative and MaestroShield makes a solid dependable product. I highly recommend MaestroShield.',
        reviewDate: '5 months ago',
        image: ASSETS.MAESTRO_SHEILD_REVIEW_3,
    },
    {
        name: 'Alex Corcoz',
        shortText: 'A Top Notch Business',
        reviewText: 'I had the pleasure of visiting MaestroShield in person, and I can confidently say this is a top-notch business with an incredible team. The employees are professional, friendly, and always willing to go the extra mile to assist their customers.',
        reviewDate: 'a year ago',
        image: ASSETS.MAESTRO_SHEILD_REVIEW_4,
    },
    {
        name: 'Yulian Fernandez',
        shortText: 'The Best Quality',
        reviewText: 'Very good place and the best quality.',
        reviewDate: '2 months ago',
        image: ASSETS.MAESTRO_SHEILD_REVIEW_5,
    },
    {
        name: 'Alison Guldenzopf',
        shortText: 'Friendly & Helpful',
        reviewText: 'Met Maria in Nashville and learned so much about this awesome product. Maria was friendly and helpful. Looking forward to offering this product in our area. Southern Exposure Sunrooms.',
        reviewDate: '6 years ago',
        image: '',
    },
    {
        name: 'Aaron Ledain',
        shortText: 'Came Through For Us',
        reviewText: 'Even though we had a warranty problem they came through for us over here at Overhead Door! Thanks guys, great products!',
        reviewDate: '7 years ago',
        image: '',
    },
];

// Hebrew copy is English for now, matches system_data_he (pending translation),
// same convention as landing-data.js.
const LOCAL_REVIEWS = {
    en: LOCAL_REVIEWS_EN,
    he: LOCAL_REVIEWS_EN,
};

// Resolves reviews from local placeholder data or the backend, per DataSourceConfig.
export const getReviewsData = async (language = 'en') => {
    const localReviews = LOCAL_REVIEWS[language] || LOCAL_REVIEWS.en;

    if (DataSourceConfig.reviews === 'local') return localReviews;

    try {
        const data = await SystemDataService.getReviews();
        return Array.isArray(data) && data.length > 0 ? data : localReviews;
    } catch (_) {
        return localReviews;
    }
};

export default getReviewsData;
